<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'

const props = defineProps<{
  module: any
  config: HomePageConfig
  cardClass?: string
  headerClass?: string
  gotoBook: (id: string) => void
  gotoCollection: (id: string) => void
}>()

function handleSeeAll() {
  props.gotoCollection(props.module.id)
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="props.cardClass"
    :header-class="props.headerClass"
    @action="handleSeeAll"
  >
    <div v-if="module.resourceList.records[0]">
      <div class="mt-5 flex items-center" @click="gotoBook(module.resourceList.records[0].id)">
        <BizBookCover
          :id="uuid()"
          :src="module.resourceList.records[0].contentCoverUrl || ''"
          :extra="{
            module_name: module.showName,
            module_id: module.id,
            module_type: module.columnType,
            author: module.resourceList.records[0]?.authorInfo?.author,
            ...module.resourceList.records[0],
          }"
          class="w-20vw flex-shrink-0 rounded-8px"
        />
        <div class="flex-1 overflow-hidden ml-3">
          <p class="text-15px text-n-text-1 font-bold line-clamp-1">
            {{ module.resourceList.records[0].contentName }}
          </p>
          <p class="text-13px mt-10px line-clamp-2 text-n-text-3">
            {{ module.resourceList.records[0].introduce }}
          </p>
          <BizShowTags v-if="module.resourceList.records[0].tagList && module.resourceList.records[0].tagList.length" :tags="module.resourceList.records[0].tagList" class="mt-10px" />
        </div>
      </div>
    </div>
    <div class="mt-5 grid grid-cols-4 gap-2">
      <div v-for="item in module.resourceList.records.slice(1, 5)" :key="item.id">
        <div class="w-20vw aspect-[3/4]!" @click="gotoBook(item.id)">
          <BizBookCover
            :id="uuid()"
            :src="item.contentCoverUrl || ''"
            :extra="{
              module_name: module.showName,
              module_id: module.id,
              module_type: module.columnType,
              author: item.authorInfo.author,
              ...item,
            }"
            class="w-full h-full rounded-8px"
          />

          <p class="mt-10px text-14px text-n-text-1 w-full line-clamp-2">
            {{ item.contentName }}
          </p>
        </div>
      </div>
    </div>
  </ModuleCard>
</template>
